import { formatNumber } from '../../../../../lib/i18n-format';
import type { ReactNode } from 'react';

// Piezas comunes de los dibujantes SVG del panel (pantalla).

export function Marker({
  shape,
  x,
  y,
  color,
  r = 4,
  hollow = false,
  ring,
}: {
  shape: string;
  x: number;
  y: number;
  color: string;
  r?: number;
  hollow?: boolean;
  /** Color del aro (el fondo), para separar marcas que se tocan. */
  ring: string;
}) {
  const style = { fill: hollow ? ring : color, stroke: color, strokeWidth: 1.75 };
  if (shape === 'square')
    return <rect x={x - r} y={y - r} width={2 * r} height={2 * r} style={style} />;
  if (shape === 'triangle')
    return (
      <path d={`M${x},${y - r - 1}L${x + r + 1},${y + r}L${x - r - 1},${y + r}Z`} style={style} />
    );
  if (shape === 'tdown')
    return (
      <path d={`M${x},${y + r + 1}L${x + r + 1},${y - r}L${x - r - 1},${y - r}Z`} style={style} />
    );
  if (shape === 'diamond')
    return (
      <path
        d={`M${x},${y - r - 1}L${x + r + 1},${y}L${x},${y + r + 1}L${x - r - 1},${y}Z`}
        style={style}
      />
    );
  return <circle cx={x} cy={y} r={r} style={style} />;
}

/** Barra con el extremo de datos redondeado (4 px), anclada a la base. */
export function Bar({
  x,
  y,
  w,
  base,
  fill,
  children,
}: {
  x: number;
  y: number;
  w: number;
  base: number;
  fill: string;
  children?: ReactNode;
}) {
  const r = Math.min(4, w / 2, Math.max(0, base - y));
  return (
    <path
      d={`M${x},${base}V${y + r}Q${x},${y} ${x + r},${y}H${x + w - r}Q${x + w},${y} ${x + w},${y + r}V${base}Z`}
      fill={fill}
    >
      {children}
    </path>
  );
}

/** Un porcentaje entero en el idioma de la app («24 %» / «24%»). */
export const pctText = (v: number) =>
  formatNumber(v, { style: 'percent', maximumFractionDigits: 0 });
